import { JobTitle } from '@connect-x-app/shared-domain-models';
import { getSecondsFromHours } from '@connect-x-app/shared-utils';
import {
  ALL_SYSTEM_MESSAGES_FUNCTIONS,
  ReceiverOptions,
  SubmitSystemMessageForm,
  SystemMessageForm,
  SystemMessageWithType,
} from '@connect-x-app/shared-view-models';

export const prepareSystemMessagesFormDataForSubmit = (
  values: SystemMessageForm,
  systemMessage: SystemMessageWithType | undefined,
): SubmitSystemMessageForm | null => {
  if (values && systemMessage) {
    let functions: JobTitle[] = [];
    if (values.receiverOption === ReceiverOptions.ALL_FUNCTIONS) {
      functions = ALL_SYSTEM_MESSAGES_FUNCTIONS;
    } else if (values.receiverOption === ReceiverOptions.SPECIFIC_FUNCTIONS) {
      functions = values.functions.map(functionListItem => functionListItem.value);
    }

    return {
      data: {
        functions,
        settings: {
          ...(systemMessage.settings ?? {}),
          timeBefore: getSecondsFromHours(Number(values.timeBeforeInHours)),
        },
      },
      messageType: systemMessage.messageType,
    };
  }

  return null;
};
